import React, { useEffect, useState } from "react";
import axios from "axios";
import AppConst from "../apis/appconst";
import { toast } from "react-toastify";
// import { RiHome4Line } from "react-icons/ri"; // Example icon import, we can map dynamically

function RoleBaseModel() {
  const [roles, setRoles] = useState([]);
  const [modules, setModules] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedModules, setSelectedModules] = useState({});
   const [openModule, setOpenModule] = useState();

  // Fetch roles
  const fetchRoles = async () => {
    try {
      const response = await axios.get(AppConst.BASE_URL + AppConst.GetAllRole);
      if (response.data.status) setRoles(response.data.list);
    } catch (err) {
      toast.error("Error fetching roles");
    }
  };

  // Fetch modules
  const fetchModules = async () => {
    try {
      const response = await axios.get(AppConst.BASE_URL + AppConst.GetAllModules); // create this API
      if (response.data.status) {
        // Group modules by module_name
        const grouped = response.data.list.reduce((acc, module) => {
          if (!acc[module.module_name]) acc[module.module_name] = [];
          acc[module.module_name].push(module);
          return acc;
        }, {});
        setModules(grouped);
      }
    } catch (err) {
      toast.error("Error fetching modules");
    }
  };

  useEffect(() => {
    
    fetchRoles();
    fetchModules();
  }, []);
  // Handle individual checkbox toggle
const handleToggle = (moduleName, subModule) => {
  setSelectedModules((prev) => {
    const currentSelection = prev[moduleName] || [];
    const newSelection = currentSelection.includes(subModule.id)
      ? currentSelection.filter((id) => id !== subModule.id)
      : [...currentSelection, subModule.id];
    return { ...prev, [moduleName]: newSelection };
  });
};

const handleSelectAll = (moduleName) => {
  const allSubmodulesInGroup = modules[moduleName].map(sub => sub.id);
  const selectedInGroup = selectedModules[moduleName] || [];

  const areAllSelected = allSubmodulesInGroup.length === selectedInGroup.length;

  setSelectedModules(prev => ({
      ...prev,
      [moduleName]: areAllSelected ? [] : allSubmodulesInGroup
  }));
};

const handleUpdateMenu = async () => {
  if (!selectedRole) {
      toast.warn("Please select a role first!");
      return;
  }

  const fd = new FormData();
  fd.append('role_id', selectedRole);

  const allSelectedIds = Object.values(selectedModules).flat();
  allSelectedIds.forEach(id => {
    fd.append('modules[]', id);  // ✅ ab sirf IDs jaayengi
  });

  try {
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.UpdateModulAssign,
          fd
      );

      if (response.data.status) {
          toast.success(response.data.message);
      } else {
          toast.error("Failed to update");
      }
  } catch (err) {
      console.error("Update error:", err);
      toast.error("Server error");
  }
};



useEffect(() => {
  if (selectedRole) {
    axios.get(AppConst.BASE_URL + AppConst.GetModuleAssign, {
      params: { role_id: selectedRole }
    }).then(res => {
      if (res.data.status) {
        const assignedModules = res.data.list; // yaha list IDs ka hona chahiye

        const grouped = {};
        Object.keys(modules).forEach(moduleName => {
          grouped[moduleName] = modules[moduleName]
            .filter(sub => assignedModules.includes(sub.id))
            .map(sub => sub.id);  // ✅ IDs use karo
        });

        setSelectedModules(grouped);
      }
    });
  }
}, [selectedRole, modules]);




  
  return (
   <div className="page-content">
      <div className="container-fluid role-management-container">
        <div className="role-management-header">
            <h3>Role Management</h3>
            <button className="btn btn-primary" onClick={handleUpdateMenu}>Update</button>
        </div>

        {/* Role select */}
        <select
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
          className="form-select mb-4"
        >
          <option value="">Select Role...</option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.role_name}
            </option>
          ))}
        </select>

        {/* Modules Accordion */}
        <div className="modules-accordion">
          {Object.keys(modules).map((moduleName) => {
            const isModuleOpen = openModule === moduleName;
            const allSubmodulesInGroup = modules[moduleName].map(sub => sub.slug);
            const selectedInGroup = selectedModules[moduleName] || [];
            const areAllSelected = allSubmodulesInGroup.length > 0 && allSubmodulesInGroup.length === selectedInGroup.length;

            return (
              <div key={moduleName} className="module-group">
                <div 
                    className="module-header" 
                    onClick={() => setOpenModule(isModuleOpen ? null : moduleName)}
                >
                  <span>{moduleName}</span>
                  <i className={`ri-arrow-down-s-line transition-transform ${isModuleOpen ? 'rotate-180' : ''}`}></i>
                </div>
                {isModuleOpen && (
                  <div className="module-content">
                    <div className="form-check select-all-checkbox mt-3">
                        <input
                            type="checkbox"
                            id={`select-all-${moduleName}`}
                            className="form-check-input"
                            checked={areAllSelected}
                            onChange={() => handleSelectAll(moduleName)}
                        />
                        <label htmlFor={`select-all-${moduleName}`} className="form-check-label" style={{fontSize: "16px"}}>
                            All Selected
                        </label>
                    </div>
                    <div className="submodules-grid">
                      {modules[moduleName].map((sub) => (
                        <div key={sub.slug} className="submodule-card">
                          <input
  type="checkbox"
  id={sub.slug}
  className="form-check-input submodule-checkbox"
  checked={selectedModules[moduleName]?.includes(sub.id) || false}
  onChange={() => handleToggle(moduleName, sub)}
/>
<label htmlFor={sub.slug} className="submodule-card-content">
  <i className={`submodule-icon ri ${sub.icon_name || 'ri-file-user-line'}`}></i>
  <span className="submodule-name">{sub.submodule_name}</span>
</label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
}

export default RoleBaseModel;
